import $ from 'jquery';
import React, { Component, Children, cloneElement } from 'react';
import PropTypes from 'prop-types';
import autobind from 'class-autobind';

import userAgentDetect from 'zoomforth_zfutils/useragent_detect.js';

import GridTile from './grid_tile.jsx';
import GridTileHover from './grid_tile_hover.jsx';
import GridTileActionIndicator from './grid_tile_action_indicator.jsx';
import GridTileWrapper from './grid_tile_wrapper.jsx';
import GridTileVideoInline from './grid_tile_video_inline_container.jsx';

import { getActionIndicatorTypeFromTileData } from 'zoomforth_codesbane_viewer/lib/tile_actions.js';
import { 
  TILE_ACTION_DATA_VIDEO_INLINE
} from 'zoomforth_codesbane_viewer/const/tile_actions.js';


const addScrollingIfNeeded = (tileWrapperRef) => {
  const $tile = $(tileWrapperRef).find('.tile');
  const $tileText =  $tile.find(' .tile-text');
  // unless text is being cut off, do not allow the tile to scroll.
  // in the viewer context, we want to dynamically change the size, so 
  // we do not set overflow hidden  in the edit context because then 
  // we would need to re-check hieght every time the font size gets changed
  
  if ($tileText.length){ // Removed: && !zfeGridUtils.isEditingContext()){
    // defer this because we don't have an accurate height until the thing is rendered
    window.setTimeout(function(){
      var scrollAmount = $tileText.outerHeight() - $tile.height();
      if(scrollAmount < parseInt($tileText.css('padding-bottom'))){
        const $formV2Tiles = $tile.find('[id^=tile-form]');
        // v2 forms have validation text that can cause scrolling when displayed.
        // To prevent parts of the form from being hidden when displaying errors we 
        // don't apply this property to those tiles
        if($formV2Tiles.length == 0){
          // if the actual text is not being cut off, do not scroll at all  
          $tile.css('overflow','hidden');
        }
        
      } else if (userAgentDetect.isMobile.iOS()){
        // if it DOES need to scroll,
        // we need to explicitly set scroll-y for ios, because scroll auto is not enough
        $tile.css('overflow-y', 'scroll');
      } else {
        $tile.css('overflow','');
      }
    }, 0);
  }
};

export const getInnerTileStyle = ({ tilePadding })=>
  ({
    top: tilePadding,
    left: tilePadding,
    bottom: tilePadding,
    right: tilePadding
  });

export const getMiddleTileStyle = ({ tileMargin })=>
  ({
    top: tileMargin,
    left: tileMargin,
    bottom: tileMargin,
    right: tileMargin
  });

export const getOuterTileStyle = ({ tileLength, row, col, sizex, sizey })=> 
  ({
    top: (tileLength * (row - 1)) + 'px',
    left: (tileLength * (col - 1)) + 'px',
    width: (tileLength * sizex) + 'px',
    height: (tileLength * sizey) + 'px'
  });


class GridTileForDesktop extends Component {

  constructor() {
    super();

    this.state = {
      isHovering: false
    };

    autobind(this);
  }
  
  render() {
    
    const { 
      className,
      captionData,
      showDefaultContents, 
      showActionOnHover,
      hasActionIcon,
      videoPlayIcon,
      tileActionIndicatorIcon,
      tileLinkHref,
      tileLinkTarget,
      doesTileLinkToVideo,
      hoverBackgroundColor,
      hoverTextColor,
      children,  
      GridTileCaptionComponent,
      shouldForceShowCaption,
      onLinkToVideoClick,
      ...props
    } = this.props;

    const actionIndicatorType = getActionIndicatorTypeFromTileData({ ...props });
    const setUpTileForLayout = (tileRef) => {
      addScrollingIfNeeded(tileRef);
    };

    const innerTileStyle = getInnerTileStyle(props);
    
    const middleTileWrapperStyle = getMiddleTileStyle(props);

    const outerTileWrapperStyle = props.outerTileWrapperStyle || getOuterTileStyle(props);

    const subpageId = props.subpage.id;

    const actionTypeName = props.actionTypeName;

    const shouldShowHover = (
      showActionOnHover &&
      actionIndicatorType &&
      actionTypeName != TILE_ACTION_DATA_VIDEO_INLINE
    );

    const modifiedInnerTileStyle = {
      ...innerTileStyle,
      backgroundColor: (this.state.isHovering && hoverBackgroundColor) ? hoverBackgroundColor : null,
      color: (this.state.isHovering && hoverTextColor) ? hoverTextColor : null,
    };

    return (
      <GridTileWrapper 
        {...{
          className,
          shouldShowHover,
          subpageId,
          hoverBackgroundColor,
          hoverTextColor,
          captionData,
          setUpTileForLayout,
          outerTileWrapperStyle, 
          middleTileWrapperStyle,
          onMouseEnter: ()=> this.setState({isHovering: true}),
          onMouseLeave: ()=> this.setState({isHovering: false}),
          ...props 
        }}
      >

        {
          (hasActionIcon && !props.hasVideoIcon && actionIndicatorType) &&
            <GridTileActionIndicator
              indicatorIcon={tileActionIndicatorIcon}
              indicatorType={actionIndicatorType}
              asset={props.asset}
              topOffsetStyle={innerTileStyle.top}
              leftOffsetStyle={innerTileStyle.left}
            />
        }

        {
          showDefaultContents && (
            actionTypeName == TILE_ACTION_DATA_VIDEO_INLINE ?
              <GridTileVideoInline
              {...{ 
                innerTileStyle: modifiedInnerTileStyle,
                videoPlayIcon,
                tileActionIndicatorIcon,
                GridTileCaptionComponent,
                shouldForceShowCaption,
                captionData,
                ...props
              }}
              />
            :
              <GridTile
                innerTileStyle={modifiedInnerTileStyle}
                videoPlayIcon={videoPlayIcon}
                tileActionIndicatorType={actionIndicatorType}
                tileActionIndicatorIcon={tileActionIndicatorIcon}
                tileLinkTarget={tileLinkTarget} 
                tileLinkHref={tileLinkHref}
                captionData={captionData}
                doesTileLinkToVideo={doesTileLinkToVideo}
                GridTileCaptionComponent={GridTileCaptionComponent}
                shouldForceShowCaption={shouldForceShowCaption}
                onLinkToVideoClick={onLinkToVideoClick}
                {...props}
              />
          )
        }
        
        { 
          shouldShowHover &&
            <GridTileHover
              indicatorType={actionIndicatorType}
              style={modifiedInnerTileStyle}
            />
        }

        { 
          Children.map(children, (child) => {
            return cloneElement(child, { modifiedInnerTileStyle: modifiedInnerTileStyle });
          })
        }
      </GridTileWrapper>
    );
  }

}

// this is in addition to any listed in GridTile
GridTileForDesktop.propTypes = {
  row: PropTypes.number.isRequired,
  col: PropTypes.number.isRequired,
  sizex: PropTypes.number.isRequired,
  sizey: PropTypes.number.isRequired,
  tilePadding: PropTypes.string.isRequired,
  tileMargin: PropTypes.string.isRequired,
  tileLength: PropTypes.number.isRequired,
  hasActionIcon: PropTypes.bool.isRequired,
  showActionOnHover: PropTypes.bool,
  showDefaultContents: PropTypes.bool
};

GridTileForDesktop.defaultProps = {
  showDefaultContents: true,
  showActionOnHover: false
};

export default GridTileForDesktop;
